import { render, staticRenderFns } from "./CaptacaoOferta.vue?vue&type=template&id=1dc06823&scoped=true&"
import script from "./CaptacaoOferta.vue?vue&type=script&lang=js&"
export * from "./CaptacaoOferta.vue?vue&type=script&lang=js&"
import style0 from "./CaptacaoOferta.vue?vue&type=style&index=0&id=1dc06823&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc06823",
  null
  
)

export default component.exports